import * as React from 'react'

import { Dialog, useDialogState } from '../../../../main/components/dialog'
import { Spinner } from '../../../../main/components/spinner'
import { useAsyncModule } from '../../../../main/services/async-modules-utils'
import { QuoteContext } from '../../QuoteContext'
import { createAlertAsyncModule } from '../../modules/create-alert/async-modules'
import { NavigationLink } from './QuoteLinkComponent'

export function CreateAlertLink() {
  const { ticker } = React.useContext(QuoteContext)
  const dialog = useDialogState()
  const isVisible = dialog.useState('open')

  const [createAlertModule] = useAsyncModule({
    ...createAlertAsyncModule,
    shouldLoadModule: isVisible,
  })
  const CreateAlert = createAlertModule?.CreateAlert

  return (
    <>
      <NavigationLink
        isEliteOnly
        utmCampaign="quote-create-alert"
        getLink={() => `/create_alert.ashx?t=${ticker}`}
        onClick={(e) => {
          if (!FinvizSettings.hasUserPremium) return
          window.gtag?.('event', 'click', { event_category: 'create-alert' })
          if (e.ctrlKey || e.metaKey) return
          e.preventDefault() // needed to prevent opening parent link
          dialog.show()
        }}
      >
        Set Alert
      </NavigationLink>
      <Dialog state={dialog} aria-label="Set Alert" className="w-[366px]">
        {CreateAlert ? (
          <CreateAlert ticker={ticker} />
        ) : (
          <div className="flex h-96 items-center justify-center">
            <Spinner />
          </div>
        )}
      </Dialog>
    </>
  )
}
